import { render, staticRenderFns } from "./customerBasicInfo.vue?vue&type=template&id=b72e3826&scoped=true"
import script from "./customerBasicInfo.vue?vue&type=script&lang=js"
export * from "./customerBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./customerBasicInfo.vue?vue&type=style&index=0&id=b72e3826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72e3826",
  null
  
)

export default component.exports